import { FormInstance } from "antd";
import CustomInput from "../../../commons/components/CustomInput/CustomInput";
import { UpdateAccountInformationFormFields } from "../../../commons/constants/formField";
import { filterECharacterInputNumber, integerOnlyInput } from "../../../commons/utils/functions/integerOnly";
import removeExtraSpace from "../../../commons/utils/functions/removeExtraSpace";
import styles from "../../../components/AccountInformation/AccountInformation.module.scss";

interface PaymentDetailProps {
  form: FormInstance;
  handleTrackFieldsTouched: (fieldName: string) => void;
}

const PaymentDetail: React.FC<PaymentDetailProps> = ({ form, handleTrackFieldsTouched }) => {
  return (
    <>
      <h2 className={styles.infoTitle}>Payment Information</h2>
      <div className={styles.detail}>
        <div className={styles.column}>
          {UpdateAccountInformationFormFields.slice(12, 16).map((field, idx) => {
            if (field.type === "number") {
              return (
                <CustomInput
                  className={styles.input}
                  label={field.title}
                  key={idx}
                  type={field.type}
                  onKeyDown={event => {
                    integerOnlyInput(event);
                  }}
                  onChange={e => {
                    handleTrackFieldsTouched(field.name);
                    filterECharacterInputNumber(field.name, form, e);
                  }}
                  maxLength={100}
                  rules={field.rule}
                  placeholder={field.placeholder}
                  name={field.name}
                  onBlur={removeExtraSpace(field.name, form)}
                  style={{ marginBottom: "0px" }}
                />
              );
            } else {
              return (
                <CustomInput
                  className={styles.input}
                  label={field.title}
                  key={idx}
                  type={field.type}
                  maxLength={100}
                  rules={field.rule}
                  placeholder={field.placeholder}
                  onChange={() => {
                    handleTrackFieldsTouched(field.name);
                  }}
                  name={field.name}
                  onBlur={removeExtraSpace(field.name, form)}
                  style={{ marginBottom: "0px" }}
                />
              );
            }
          })}
        </div>
        <div className={[styles.column, styles.secondColumn].join(" ")}>
          {UpdateAccountInformationFormFields.slice(16).map((field, idx) => {
            if (field.type === "number") {
              return (
                <CustomInput
                  className={styles.input}
                  label={field.title}
                  key={idx}
                  type={field.type}
                  onKeyDown={event => {
                    integerOnlyInput(event);
                  }}
                  onChange={e => {
                    handleTrackFieldsTouched(field.name);
                    filterECharacterInputNumber(field.name, form, e);
                  }}
                  maxLength={100}
                  rules={field.rule}
                  placeholder={field.placeholder}
                  name={field.name}
                  onBlur={removeExtraSpace(field.name, form)}
                  style={{ marginBottom: "0px" }}
                />
              );
            } else {
              return (
                <CustomInput
                  className={styles.input}
                  key={idx}
                  label={field.title}
                  type={field.type}
                  onChange={e => {
                    handleTrackFieldsTouched(field.name);
                  }}
                  maxLength={100}
                  rules={field.rule}
                  placeholder={field.placeholder}
                  name={field.name}
                  onBlur={removeExtraSpace(field.name, form)}
                  style={{ marginBottom: "0px" }}
                />
              );
            }
          })}
        </div>
      </div>
    </>
  );
};

export default PaymentDetail;
